export class PricingItemVersion {
    public readonly id?: string
}